<template>
  <div class="navigation-buttons-container">
    <div class="d--f jc--sb ai--c">
      <AppButton v-if="store.currentStep > 0" variant="outlined" class="mw-150px" @click="store.prevStep" type="button">
        Previous
      </AppButton>
      <div v-else class="mw-150px"></div>
      <div>
        <AppButton
          v-if="store.currentStep < totalSteps - 1"
          variant="primary"
          class="mw-150px"
          @click="handleNextStep"
          type="button"
        >
          Next
        </AppButton>
        <AppButton v-else variant="primary" type="submit" class="mw-150px" :disabled="!store.isFormValid" @click="handleSubmit">
          Generate report
        </AppButton>
      </div>
    </div>
  </div>
</template>

<script setup>
import { AppButton } from "@/components/ui";
import { useReportFormStore } from "@/stores/reportFormStore";

defineProps({
  totalSteps: {
    type: Number,
    required: true
  }
});

const emit = defineEmits(['next-step', 'submit']);

const store = useReportFormStore();

const handleNextStep = () => {
  emit('next-step');
};

const handleSubmit = () => {
  emit('submit');
};
</script>

<style lang="scss" scoped>
.navigation-buttons-container {
  position: fixed;
  bottom: 0;
  left: 80px;
  right: 0;
  background-color: white;
  padding: 20px 30px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 10;
  max-width: 800px;
  margin: 0 auto;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.mw-150px {
  min-width: 150px;
}
</style>
